export default "__VITE_ASSET__DveAMSKw__"